import { render, staticRenderFns } from "./orthopedic-card-basic.vue?vue&type=template&id=742a12bc&scoped=true&"
import script from "./orthopedic-card-basic.vue?vue&type=script&lang=js&"
export * from "./orthopedic-card-basic.vue?vue&type=script&lang=js&"
import style0 from "./orthopedic-card-basic.vue?vue&type=style&index=0&id=742a12bc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "742a12bc",
  null
  
)

export default component.exports